import { CheckIcon, XMarkIcon } from "@heroicons/react/24/solid";
import Button from "../layout/Button";
import { translateText } from "../../utils/translation";

interface SelectOrUnselectAllProps {
  handler: (e: any, args: any[]) => void;
  language: string;
}

export default function SelectOrUnselectAll({
  handler,
  language,
}: SelectOrUnselectAllProps) {
  return (
    <div className="grid grid-cols-2">
      <Button
        type="button"
        className={`group inline-flex justify-center rounded-lg py-2 px-3 text-sm font-semibold outline-2 outline-offset-2 transition-colors bg-transparent text-success hover:bg-success/30 hover:text-success-dark`}
        onClick={handler}
        onClickArgs={[true]}
      >
        <CheckIcon
          className={`h-5 w-5 text-success group-hover:text-success-dark mr-1`}
          aria-hidden="true"
        />
        <span className="text-success-dark group-hover:text-success-dark">
          {translateText("select_all", language)}
        </span>
      </Button>
      <Button
        type="button"
        className={`group inline-flex justify-center rounded-lg py-2 px-3 text-sm font-semibold outline-2 outline-offset-2 transition-colors bg-transparent text-warning hover:bg-warning/30 hover:text-warning-dark`}
        onClick={handler}
        onClickArgs={[false]}
      >
        <XMarkIcon
          className={`h-5 w-5 text-warning group-hover:text-warning-dark mr-1`}
          aria-hidden="true"
        />
        <span className="text-warning group-hover:text-warning-dark">
          {translateText("unselect_all", language)}
        </span>
      </Button>
    </div>
  );
}
